import Iconify from "@/components/ui/Iconify";
import Modal from "@/components/ui/modal";
import { useTranslations } from "@/lib/static-intl";

const DeleteNotesWarningModal = ({ loading, isOpen, onClose, onConfirm }) => {
  const t = useTranslations("creator_service.creator_note_manager");
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title={t("Delete Note")}
      className={""}
      titleClass={""}
      contentClass={""}
    >
      <div className="w-full flex flex-col gap-4">
        <span className="text-black dark:text-dark_primary_label">
          {t("Are you sure you want to delete this Note?")}
        </span>
        <div className="w-full flex items-center justify-end gap-5">
          <button
            type="button"
            className="text-dark_bg_grey dark:text-dark_tertiary_label cursor-pointer border border-gray-300 p-1"
            onClick={onClose}
            disabled={loading}
          >
            {t("Cancel")}
          </button>
          <button
            type="button"
            className={`bg-red flex items-center gap-1 p-1 text-white px-3 rounded cursor-pointer ${
              loading && "!cursor-not-allowed opacity-70"
            }`}
            onClick={onConfirm}
            disabled={loading}
          >
            {loading && (
              <Iconify
                icon={"line-md:loading-loop"}
                className={`!text-inherit ${loading && "!cursor-not-allowed"}`}
              />
            )}
            {t("Delete")}
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default DeleteNotesWarningModal;
